const documentationMocks = {
  "meeting1": {
    "technical": {
      title: "Техническая документация API: Масштабирование микросервисной архитектуры",
      content: `
# Техническая документация API: Масштабирование микросервисной архитектуры

## Общий обзор архитектуры
Наша микросервисная архитектура построена на принципах REST и состоит из 15+ сервисов, включая аутентификацию, обработку платежей, управление заказами, и аналитику.

## Технические требования
- Golang 1.18+ для сервисов бэкенда
- Node.js 16+ для API-шлюза
- MongoDB 5.0 для хранения данных
- Redis 6.2 для кэширования
- Kafka для асинхронной коммуникации
- Docker & Kubernetes для оркестрации

## Основные API endpoints
\`\`\`
GET /api/v2/orders
POST /api/v2/orders
GET /api/v2/orders/{id}
PUT /api/v2/orders/{id}
DELETE /api/v2/orders/{id}
\`\`\`

### Пример запроса
\`\`\`json
POST /api/v2/orders
Content-Type: application/json
Authorization: Bearer {token}

{
  "customer_id": "cust_9e8d7c6b5a",
  "items": [
    {
      "product_id": "prod_1a2b3c4d5e",
      "quantity": 2,
      "price": 1299.99
    }
  ],
  "shipping_address": {
    "line1": "ул. Ленина, 12",
    "city": "Москва",
    "postal_code": "123456",
    "country": "Россия"
  },
  "payment_method": "card_f7e6d5c4b3"
}
\`\`\`

### Пример ответа
\`\`\`json
{
  "order_id": "ord_5f4e3d2c1b",
  "status": "created",
  "total": 2599.98,
  "created_at": "2023-04-12T15:30:45Z",
  "estimated_delivery": "2023-04-17T12:00:00Z"
}
\`\`\`

## Стратегия шардирования БД
Для улучшения масштабирования мы внедрили шардирование по customer_id, используя следующие параметры:

\`\`\`javascript
db.createCollection("orders", {
  shardKey: { "customer_id": "hashed" },
  numInitialChunks: 16
})
\`\`\`

Это позволило равномерно распределить нагрузку и увеличить пропускную способность на 320%.
`
    },
    "management": {
      title: "Обзор для руководства: Масштабирование микросервисной архитектуры",
      content: `
# Обзор для руководства: Масштабирование микросервисной архитектуры

## Ключевые достижения

✅ **Увеличение пропускной способности на 320%**  
✅ **Снижение времени отклика на 65%**  
✅ **Сокращение затрат на инфраструктуру на 18%**  
✅ **Повышение отказоустойчивости до 99.99%**  

## Финансовые результаты

| Метрика | До обновления | После обновления | Изменение |
|---------|---------------|------------------|-----------|
| Средний чек | 4,200₽ | 4,850₽ | +15.5% |
| Конверсия | 2.3% | 3.7% | +60.9% |
| Отказы от корзины | 24% | 12% | -50% |
| Выручка (мес.) | 28.5M₽ | 46.2M₽ | +62.1% |
`
    },
    "user": {
      title: "Руководство пользователя: Новые возможности системы после обновления",
      content: `
# Руководство пользователя: Новые возможности системы после обновления

## Что изменилось

Дорогие пользователи!

Мы рады сообщить, что наша система стала еще лучше! В новой версии вас ждут:

### 🚀 Повышенная скорость
Все операции теперь выполняются в 2-3 раза быстрее

### 🛡️ Улучшенная стабильность
Система стала еще более устойчивой к нагрузкам

### 🔄 Синхронизация между устройствами
Теперь вы можете начать работу на компьютере и продолжить на смартфоне
`
    }
  },
  "meeting2": {
    "technical": {
      title: "Техническая документация: Непрерывная интеграция и доставка (CI/CD)",
      content: `
# Техническая документация: Непрерывная интеграция и доставка (CI/CD)

## Архитектура CI/CD

![CI/CD Архитектура](https://example.com/cicd-architecture.png)

### Компоненты системы

| Компонент | Технология | Назначение |
|-----------|------------|------------|
| Система контроля версий | Git (GitHub) | Хранение исходного кода и управление версиями |
| CI-сервер | Jenkins | Автоматизация сборки и тестирования |
| Репозиторий артефактов | Nexus | Хранение собранных артефактов |
`
    },
    "management": {
      title: "Отчет для руководства: Внедрение методологии CI/CD",
      content: `
# Отчет для руководства: Внедрение методологии CI/CD

## Ключевые результаты

- **Сокращение времени выпуска новых версий** с 2 недель до 2 дней
- **Снижение количества критических ошибок** в production на 78%
- **Увеличение частоты обновлений** с 1 раза в месяц до 3 раз в неделю
- **Экономия ресурсов команды разработки** на 23%

## Экономический эффект

Внедрение CI/CD позволило сэкономить около 12 миллионов рублей в год за счет:
`
    },
    "user": {
      title: "Что такое непрерывная доставка обновлений",
      content: `
# Что такое непрерывная доставка обновлений

## Важная информация для пользователей

Дорогие пользователи!

Мы перешли на новую модель доставки обновлений, которая называется "непрерывная доставка" (Continuous Delivery). Что это значит для вас?

### Более частые обновления

Раньше мы выпускали крупные обновления раз в месяц. Теперь вы будете получать небольшие улучшения несколько раз в неделю.

### Меньше сбоев

Благодаря более частым и небольшим обновлениям, мы можем быстрее находить и исправлять ошибки, что делает работу системы более стабильной.

### Быстрая реакция на ваши запросы

Если вы предложите улучшение или сообщите о проблеме, мы сможем реализовать изменения гораздо быстрее, чем раньше.

## Часто задаваемые вопросы

### Нужно ли мне что-то делать для получения обновлений?
Нет, все обновления устанавливаются автоматически при входе в систему.

### Будет ли система недоступна во время обновлений?
Нет, мы используем специальную технологию, которая позволяет обновлять систему без прерывания работы.

### Как узнать, что было добавлено в новом обновлении?
После каждого значимого обновления вы будете видеть уведомление со списком изменений.
`
    }
  },
  "meeting3": {
    "technical": {
      title: "API документация: Интеграция с платежными системами",
      content: `
# API документация: Интеграция с платежными системами

## Обзор API

Это руководство предназначено для разработчиков, которые хотят интегрировать платежные функции в свои приложения. Наше API поддерживает следующие платежные системы:

- Visa, Mastercard, МИР
- Apple Pay, Google Pay
- ЮMoney, QIWI
- Системы быстрых платежей (СБП)

## Аутентификация

Все API-запросы должны быть аутентифицированы с использованием API-ключа. Ключ передается в заголовке \`X-API-Key\`.

\`\`\`http
GET /api/payments
Host: api.example.com
X-API-Key: your_api_key_here
\`\`\`

## Создание платежа

### Запрос

\`\`\`http
POST /api/payments
Content-Type: application/json
X-API-Key: your_api_key_here

{
  "amount": 1000.00,
  "currency": "RUB",
  "description": "Оплата заказа #12345",
  "customer": {
    "email": "customer@example.com",
    "phone": "+79001234567"
  },
  "return_url": "https://your-site.com/success",
  "webhook_url": "https://your-site.com/webhook",
  "metadata": {
    "order_id": "12345"
  }
}
\`\`\`

### Ответ

\`\`\`json
{
  "payment_id": "pay_8f7g6h5j",
  "status": "pending",
  "amount": 1000.00,
  "currency": "RUB",
  "payment_url": "https://checkout.example.com/pay/8f7g6h5j",
  "created_at": "2023-05-15T08:45:30Z",
  "expires_at": "2023-05-15T09:45:30Z"
}
\`\`\`
`
    },
    "management": {
      title: "Бизнес-обзор: Внедрение новой платежной системы",
      content: `
# Бизнес-обзор: Внедрение новой платежной системы

## Резюме проекта

Уважаемое руководство,

Мы успешно завершили внедрение новой платежной системы, которая расширяет возможности оплаты для наших клиентов и оптимизирует процесс обработки транзакций для нашего бизнеса.

## Показатели эффективности

📈 **Рост конверсии платежей на 24%**
- До внедрения: 76% успешных платежей
- После внедрения: 94% успешных платежей

💰 **Снижение комиссий на 1.2%**
- Предыдущие расходы: 2.8% + 30₽ за транзакцию
- Новые расходы: 1.6% + 20₽ за транзакцию
- Годовая экономия: ~₽3.8 млн.

⏱️ **Ускорение обработки платежей**
- Среднее время обработки платежа сократилось с 8 секунд до 2.5 секунд
`
    },
    "user": {
      title: "Новый интерфейс приложения: Что изменилось и как использовать новые функции",
      content: `
# Новый интерфейс приложения: Что изменилось и как использовать новые функции

## Добро пожаловать в обновленную версию!

Дорогие пользователи!

Мы рады представить вам полностью обновленный интерфейс приложения. Мы провели масштабную работу, чтобы сделать его быстрее, удобнее и современнее. В этом руководстве мы расскажем обо всех изменениях и новых возможностях.

![Новый интерфейс](https://example.com/new-interface.png)

## Что нового?

### Современный дизайн
Мы полностью переработали визуальный стиль приложения, сделав его более современным и приятным для глаз.

### Молниеносная скорость
Приложение стало работать в 2.5 раза быстрее! Страницы загружаются практически мгновенно, а все действия выполняются без задержек.

### Удобная навигация
Перемещаться между разделами стало проще благодаря новому боковому меню и улучшенной системе поиска.

### Адаптивный дизайн
Приложение теперь отлично работает на любых устройствах — от смартфонов до больших мониторов.

### Темная тема
По многочисленным просьбам мы добавили темную тему, которая снижает нагрузку на глаза и экономит заряд батареи.

## Знакомство с новым интерфейсом

### Главный экран

![Главный экран](https://example.com/main-screen.png)

1. **Боковое меню** — нажмите на иконку ☰ в левом верхнем углу, чтобы открыть или скрыть меню
2. **Панель поиска** — быстрый поиск по всему приложению
3. **Уведомления** — все важные события собраны в одном месте
4. **Профиль** — доступ к настройкам аккаунта и личным данным
5. **Дашборд** — персонализированная сводка информации

### Новая система навигации

В боковом меню теперь отображаются:

- **Главные разделы** — основные функции приложения
- **Избранное** — ваши часто используемые разделы
- **Последние** — недавно посещенные страницы

Вы можете настроить боковое меню под себя:

1. Нажмите на ⚙️ в нижней части меню
2. Выберите разделы, которые хотите видеть
3. Перетащите их в нужном порядке

## Новые функции

### Персонализация дашборда

Теперь вы можете настроить главный экран под свои потребности:

1. Нажмите "Редактировать дашборд" в правом верхнем углу
2. Добавьте нужные виджеты из каталога
3. Расположите их в удобном порядке
4. Настройте размер и содержимое каждого виджета

![Персонализация дашборда](https://example.com/dashboard-customization.png)

### Улучшенный поиск

Новая система поиска стала намного умнее:

- **Мгновенные результаты** — результаты появляются по мере ввода запроса
- **Контекстный поиск** — система понимает, в каком разделе вы находитесь
- **Интеллектуальные подсказки** — предлагает исправления и популярные запросы
- **Фильтры** — можно уточнить поиск по типу контента, дате и другим параметрам

### Оффлайн-режим

Теперь вы можете работать с приложением даже без интернета:

1. Включите оффлайн-режим в настройках
2. Данные будут кэшироваться на вашем устройстве
3. Внесенные изменения синхронизируются, когда соединение восстановится

## Как включить темную тему

Многие пользователи просили добавить темную тему, и мы это сделали!

1. Нажмите на значок профиля в правом верхнем углу
2. Выберите "Настройки"
3. Перейдите в раздел "Внешний вид"
4. Выберите "Темная тема" или "Автоматически" (будет меняться в зависимости от времени суток)

![Темная тема](https://example.com/dark-theme.png)

## Часто задаваемые вопросы

### Где мои сохраненные данные?
Все ваши данные автоматически перенесены в новую версию. Они доступны в тех же разделах, что и раньше, но с улучшенным интерфейсом.

### Как вернуться к старому интерфейсу?
На протяжении следующих 3 месяцев у вас будет возможность переключаться между новым и старым интерфейсом. Для этого нажмите на свой профиль → Настройки → "Использовать классический интерфейс".

### Нужно ли мне заново учиться работать с приложением?
Нет, все основные функции работают так же, как и раньше, просто стали удобнее и приятнее в использовании. Логика основных операций не изменилась.

### Что делать, если я не могу найти нужную функцию?
Используйте поиск! Просто введите название функции в поисковую строку. Также вы можете обратиться в нашу службу поддержки через чат в правом нижнем углу.

## Что дальше?

В ближайшие месяцы мы планируем выпустить еще несколько обновлений:

- **Расширенная статистика** — новые графики и отчеты
- **Интеграция с календарем** — синхронизация задач и встреч
- **Мобильное приложение** — полноценная работа на смартфоне

## Нужна помощь?

Если у вас возникли вопросы или сложности при использовании нового интерфейса:

- **Обучающие видео**: [example.com/tutorials](https://example.com/tutorials)
- **Чат поддержки**: нажмите на иконку 💬 в правом нижнем углу
- **Email**: support@example.com
- **Телефон**: 8-800-123-45-67 (с 9:00 до 21:00 по Москве)

Мы надеемся, что новый интерфейс сделает вашу работу ещё продуктивнее и приятнее!

С уважением,
Команда разработки
      `
    }
  }
};

export default documentationMocks; 